module.exports = __webpack_public_path__ + "img/logo-name.b481520c.png";